<template>
  <v-card class="pa-5" outlined style="background-color: rgba(0,0,0,0)">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-avatar size="84">
          <v-img :src="participantData.profilePicture != null? participantData.profilePicture :
           'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"/>
        </v-avatar>
      </v-row>
      <v-row align="center" class="mt-5" justify="center">
        <div>
          <h2 class="text-center">
            {{ basicUserInfo }}
            <Flag v-if="countryCode !== null" :code="countryCode" size="S"/>
          </h2>
          <p class="text-center">{{ $t('joinedWith') }}
            {{ participantData.brokerAccountIdentifier }} -
            {{ participantData.brokerName }}
          </p>
          <v-chip v-if="notConsistent"
                  class="d-flex justify-center text-center my-2" color="error" small>
            {{ (notPositive)? $t('alerts.notPositive') : $t('alerts.notConsistent')  }}
            <v-icon class="ml-2" color="white" small>fa-exclamation-circle</v-icon>
          </v-chip>
          <v-chip v-else-if="disqualified"
                  class="d-flex justify-center text-center my-2" color="error" small>
            {{ $t('alerts.disqualified')  }}
            <v-icon class="ml-2" color="white" small>fa-exclamation-triangle</v-icon>
          </v-chip>
          <h3 v-if="participantData.status === 'ACTIVE'" class="text-center mt-2">
            {{ $t(`rankTypes.${rankingType}`) }}:
            {{ participantData.score !== null? (rankingType.includes('PERCENTAGE'))? `${(participantData.score * 100).toFixed(2)}%` :
              participantData.score.toFixed(2) : '---' }}
            &nbsp; | &nbsp;
            {{ getRank() }} ° {{ $t('atRank') }}</h3>
          <!--v-btn class="mt-3" style="width: 100%" @click="seeDistribution">
            {{ $t('btnDistribution') }}
            <v-icon v-if="participantData.participantStatus === 'PAUSED'" class="ml-2" color="red darken-1" small>
              fa-exclamation-circle
            </v-icon>
          </v-btn-->
        </div>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import CountriesData from "@/views/Register/countries";
export default {
  name: "UserSummary",
  props: {
    rankingType: String,
    participants: Array,
    participantData: Object,
  },
  data() {
    return {
      countries: CountriesData,
    };
  },
  computed: {
    notConsistent() {
      return (this.participantData !== undefined)?
          this.participantData.status === 'PAUSED' : false;
    },
    notPositive() {
      return (this.participantData !== undefined)? // TODO Re-organize rule to be widely accepted
          this.participantData.status === 'PAUSED' && this.$store.state.tournament.tournamentOrganizerId === 54 : false;
    },
    disqualified() {
      return (this.participantData !== undefined)?
          this.participantData.status === 'DISQUALIFIED' : false;
    },
    basicUserInfo(){
      return (this.participantData !== undefined)?
          `${this.participantData.firstName} ${this.participantData.lastName}` : '';
    },
    countryCode() {
      let countryFound = this.countries.find((country) => country.name === this.participantData.country );
      return (countryFound !== undefined)? countryFound.code : null;
    }
  },
  methods: {
    getRank() {
      let rankPosition = this.participants.filter((participant) => participant.status === 'ACTIVE').findIndex((activeParticipant) => activeParticipant.participantId === this.participantData.participantId);
      return (rankPosition === -1)? '---' : `${rankPosition + 1}`;
    },
    seeDistribution() {
      this.$emit('seeDistribution');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "joinedWith": "Joined with",
    "alerts": {
      "notConsistent": "You are not consistent",
      "notPositive": "You are not profitable",
      "disqualified": "You were disqualified"
    },
    "rankTypes": {
      "SWISET_RATIO": "Swiset Ratio",
      "BALANCE": "Balance",
      "PERFORMANCE_RATIO": "Performance Ratio",
      "PROFIT_PERCENTAGE": "% Profit",
      "EQUITY_RT": "Equity"
    },
    "atRank": "at rank",
    "btnDistribution": "See Trades Distribution"
  },
  "es": {
    "joinedWith": "Participando con",
    "alerts": {
      "notConsistent": "No eres consistente",
      "notPositive": "No eres rentable",
      "disqualified": "Fuiste descalificado"
    },
    "rankTypes": {
      "SWISET_RATIO": "Ratio Swiset",
      "BALANCE": "Balance",
      "PERFORMANCE_RATIO": "Ratio Rendimiento",
      "PROFIT_PERCENTAGE": "% Retorno",
      "EQUITY_RT": "Equidad"
    },
    "atRank": "en ranking",
    "btnDistribution": "Distribución de Trades"
  }
}
</i18n>

<style scoped>

</style>
